import React, { ReactElement,  useEffect,  useState } from 'react';
import { Button, TextField, Dialog, DialogActions, DialogContent, DialogTitle, CircularProgress } from '@mui/material';
import { CanvasEnvironment } from '../../../utils/canvas/canvas-environment';
import Paper, { PaperProps } from '@mui/material/Paper';
import Draggable from 'react-draggable';
import { uuid } from '../../../utils/utils';
import CancelIcon from '@mui/icons-material/Cancel';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import EventSequenceService from '../../../services/event-sequence.service';
import { toast } from 'react-toastify';
import * as CanvasActions from '../../../utils/canvas/canvas-actions';

function PaperComponent(props: PaperProps): ReactElement {
    const nodeRef = React.useRef(null);
    return (
        <Draggable nodeRef={nodeRef} handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
            <Paper {...props} ref={nodeRef} />
        </Draggable>
    );
}


const OdnaComment = (props: { open: boolean, env: CanvasEnvironment | null, onClose: () => void } ): React.ReactElement => {
    const {open, env, onClose} = props;
    const [comment, setComment] = useState('');
    const [isRunning, setIsRunning] = React.useState<boolean>(false);
    const uuidRef = React.useRef(uuid());


    useEffect(() => {
        if (open && env) {
            let selection = env.selection[0];
            if (selection) {
                if (selection.get('nodeClass') === 'EVENTNODE') {
                    let dnaLink = env.currentLinkedOccurrenceDna?.events.find((event) => event.id === selection.get('data').id);
                    if (dnaLink) {
                        setComment(dnaLink.comment);
                    }
                } else if (selection.get('nodeClass') === 'FAULTTREENODE') {
                    let dnaLink = env.currentLinkedOccurrenceDna?.faultTreeNodes.find((node) => node.id === selection.get('data').id);
                    if (dnaLink) {
                        setComment(dnaLink.comment);
                    }
                }
            }         
        }
    }, [env, open]);

    const handleSave = async (): Promise<void> => {
        let selection = env?.selection[0];
        if (selection) {
            if (selection.get('nodeClass') === 'EVENTNODE') {
                let dnaLink = env?.currentLinkedOccurrenceDna?.events.find((event) => event.id === selection.get('data').id);
                if (dnaLink) {
                    dnaLink.comment = comment;
                    return EventSequenceService.putLinkedOccurrenceDna(env?.currentLinkedOccurrenceDna!);
                }
            } else if (selection.get('nodeClass') === 'FAULTTREENODE') {
                let dnaLink = env?.currentLinkedOccurrenceDna?.faultTreeNodes.find((node) => node.id === selection.get('data').id);
                if (dnaLink) {
                    dnaLink.comment = comment;
                    return EventSequenceService.putLinkedOccurrenceDna(env?.currentLinkedOccurrenceDna!);
                }
            }
        }
    };

    return (
        <Dialog open={open}
            onClose={onClose}
            PaperComponent={PaperComponent}
            aria-labelledby="draggable-dialog-title"
            fullWidth
            maxWidth='sm'
        >
            <DialogTitle style={{ cursor: 'move'}} id='draggable-dialog-title'>Add Comments</DialogTitle>
            <DialogContent dividers>
                <TextField
                    autoFocus
                    margin="dense"
                    id={`comment-id-${uuidRef.current}`}
                    label="Comment (optional)"
                    type="text"
                    multiline
                    rows={4}
                    value={comment}
                    onChange={(e): void => setComment(e.target.value)}
                    sx={{
                        '& input': {
                            border: 'none',
                        }
                    }}
                    slotProps={{
                        input: {
                            'role': 'textbox',
                            'tabIndex': 0,
                            'aria-labelledby': `comment-id-${uuidRef.current}`,
                            'aria-label': 'comment',
                        }
                    }}
                    fullWidth

                />
            </DialogContent>
            <DialogActions>
                <Button
                    variant='contained'
                    color='secondary'
                    startIcon={<CancelIcon />}
                    onClick={onClose}>
                        Cancel
                </Button>
                <Button
                    variant='contained'
                    color="primary"
                    startIcon={isRunning ? <CircularProgress size={20} /> : <SaveAltIcon />}
                    onClick={async (): Promise<void> => {
                        setIsRunning(true);
                        try {
                            await handleSave();
                            toast.success('Comment saved successfully');
                        } catch (e) {
                            toast.error('Failed to save comment');
                        } finally {
                            setIsRunning(false);
                            onClose();
                        }
                    }}
                    disabled={isRunning || !CanvasActions.canAddOrEditResource(env)}
                >
                        Save
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default OdnaComment;